export const Svg_Arrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <g transform="translate(-1 0.5)" fill="currentColor" stroke="none">
        <path d="M-4517.5 1312a1.5 1.5 0 0 1-1.5-1.5v-5a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5v3.5h3.5a1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5z" transform="rotate(-135 -2522.135 -278.7)" />
      </g>
    </svg>
  )
}

export const Svg_Arrow2 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <g transform="translate(-1 0.5)" fill="currentColor" stroke="none">
        <path d="M-4517.5 1312a1.5 1.5 0 0 1-1.5-1.5v-5a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5v3.5h3.5a1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5z" transform="rotate(-135 -2521.135 -279.115)" />
        <path d="M-4517.5 1312a1.5 1.5 0 0 1-1.5-1.5v-5a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5v3.5h3.5a1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5z" transform="rotate(-135 -2523.807 -278.008)" />
      </g>
    </svg>
  )
}

export const Svg_Info = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <g transform="translate(5.925 5.924)" fill="currentColor" stroke="currentColor">
        <circle fill="none" strokeWidth="1.5" cx="9.326" cy="9.326" r="9.326" transform="translate(.75 .75)" />
        <g stroke="none">
          <path d="M11.614 6.609a1.539 1.539 0 1 1-1.538-1.538 1.538 1.538 0 0 1 1.538 1.538" />
          <path d="M10.978 9h-1.8a.637.637 0 0 0-.637.636v4.812a.637.637 0 0 0 .637.636h1.8a.636.636 0 0 0 .636-.636V9.633A.636.636 0 0 0 10.978 9" />
        </g>
      </g>
    </svg>
  )
}

export const Svg_Alarm = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <g transform="translate(6.753 5.924)" fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path d="M15.484 11.28V7.256A6.418 6.418 0 0 0 9.859.78a6.238 6.238 0 0 0-6.85 6.208v4.292a1.285 1.285 0 0 1-.237.743L.988 14.544a1.288 1.288 0 0 0 1.051 2.031h14.415a1.287 1.287 0 0 0 1.05-2.031l-1.784-2.521a1.291 1.291 0 0 1-.236-.743z" />
        <path d="M12.074 16.574a2.827 2.827 0 0 1-5.654 0" />
      </g>
    </svg>
  )
}